import { makeObservable } from 'mobx';
import { SITUACAO_PUBLICACAO_PAUTA } from '../../dominio/SituacaoPublicacaoPauta';
import { Filtro } from './Filtro';
import moment from 'moment';

export default class FiltroDataPublicacaoPauta extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Data de publicação';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        if (registro.materiaPublicacaoPauta?.dataRealDisponibilizacao) {
            return this.store.rootStore.dominioStore.getProximaDataUtilPublicacao(
                registro.materiaPublicacaoPauta.dataRealDisponibilizacao,
                'DD-MM-YYYY',
                'DD/MM/YYYY'
            );
        }

        const situacaoId = registro.materiaPublicacaoPauta?.situacao;

        const situacoesPublicacao = [
            SITUACAO_PUBLICACAO_PAUTA.LIBERADO_PARA_DISPONIBILIZACAO.id,
            SITUACAO_PUBLICACAO_PAUTA.DISPONIBILIZADO.id,
            SITUACAO_PUBLICACAO_PAUTA.DISPONIBILIZADO_PARCIALMENTE.id
        ];

        if ((situacaoId && situacoesPublicacao.indexOf(situacaoId) !== -1) || registro.confirmadaPublicacaoPauta) {
            return 'DATA DESCONHECIDA';
        }
    }
}
